import React, { useState, useEffect } from "react";
import s from "./ManageEvents.module.css";
import commonStyles from '../../common/CommonStyles.module.css';

const ManageEvents = () => {
  const [events, setEvents] = useState([]);
  const [newEventName, setNewEventName] = useState("");
  const [newEventDescription, setNewEventDescription] = useState("");
  const [newEventDate, setNewEventDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [editingEvent, setEditingEvent] = useState(null);

  // Загрузка всех событий
  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const response = await fetch("/api/events");
      if (!response.ok) throw new Error("Ошибка при загрузке событий");
      const data = await response.json();
      setEvents(data);
    } catch (error) {
      console.error("Error fetching events:", error);
      setErrorMessage("Ошибка при загрузке событий");
    } finally {
      setLoading(false);
    }
  };

  // Добавление события
  const handleAddEvent = async () => {
    if (!newEventName || !newEventDescription) {
      setErrorMessage("Заполните все обязательные поля");
      return;
    }

    try {
      const response = await fetch("/api/events", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          eventName: newEventName,
          description: newEventDescription,
          eventDate: newEventDate || null,
        }),
      });
      if (!response.ok) throw new Error("Ошибка при добавлении события");
      const newEvent = await response.json();
      setEvents((prev) => [...prev, newEvent]);
      setNewEventName("");
      setNewEventDescription("");
      setNewEventDate("");
    } catch (error) {
      console.error("Error adding event:", error);
      setErrorMessage("Ошибка при добавлении события");
    }
  };

  // Удаление события
  const handleDeleteEvent = async (eventId) => {
    if (!window.confirm("Удалить событие?")) return;

    try {
      const response = await fetch(`/api/events/${eventId}`, {
        method: "DELETE",
      });
      if (!response.ok) throw new Error("Ошибка при удалении события");
      setEvents((prev) => prev.filter((e) => e.id !== eventId));
    } catch (error) {
      console.error("Error deleting event:", error);
      setErrorMessage("Ошибка при удалении события");
    }
  };

  // Редактирование события
  const handleEditEvent = async (eventId, updatedEvent) => {
    try {
      const response = await fetch(`/api/events/${eventId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedEvent),
      });
      if (!response.ok) throw new Error("Ошибка при редактировании события");
      const updatedData = await response.json();
      setEvents((prev) =>
          prev.map((e) => (e.id === eventId ? updatedData : e))
      );
      setEditingEvent(null);
    } catch (error) {
      console.error("Error editing event:", error);
      setErrorMessage("Ошибка при редактировании события");
    }
  };

  return (
    <div className={commonStyles.pageContainer}>
      <div className={commonStyles.contentContainer}>
        <div className={commonStyles.content}>
          <h2 style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>
            Управление событиями
          </h2>
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
            <input
              type="text"
              placeholder="Название события"
              value={newEventName}
              onChange={(e) => setNewEventName(e.target.value)}
              style={{ flex: 1, minWidth: 220, maxWidth: 400, padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
            />
            <textarea
              placeholder="Описание события"
              value={newEventDescription}
              onChange={(e) => setNewEventDescription(e.target.value)}
              style={{ flex: 2, minWidth: 220, maxWidth: 600, padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem', minHeight: 40 }}
            />
            <input
              type="date"
              placeholder="Дата события"
              value={newEventDate}
              onChange={(e) => setNewEventDate(e.target.value)}
              style={{ flex: 1, minWidth: 220, maxWidth: 400, padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem' }}
            />
            <button
              onClick={handleAddEvent}
              style={{ backgroundColor: 'rgb(151, 1, 14)', color: 'white', borderRadius: 4, fontWeight: 500, padding: '0.8rem 1.5rem', fontSize: '1rem' }}
            >
              Добавить событие
            </button>
          </div>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'rgb(151, 1, 14)' }}>Загрузка...</div>
          ) : events.length > 0 ? (
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 600, borderRadius: 8, overflow: 'hidden' }}>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Описание</th>
                  <th>Дата</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                {events.map((event) => (
                  <tr key={event.id} style={{ borderBottom: '1px solid #e0e0e0' }}>
                    <td>{event.eventName}</td>
                    <td>{event.description}</td>
                    <td>{event.eventDate ? new Date(event.eventDate).toLocaleDateString('ru-RU') : '-'}</td>
                    <td>
                      <button
                        onClick={() => setEditingEvent(event)}
                        style={{ backgroundColor: '#2196F3', color: 'white', borderRadius: 4, marginRight: 8, padding: '8px 16px', fontSize: '0.9rem' }}
                      >
                        Редактировать
                      </button>
                      <button
                        onClick={() => handleDeleteEvent(event.id)}
                        style={{ backgroundColor: '#ff4444', color: 'white', borderRadius: 4, padding: '8px 16px', fontSize: '0.9rem' }}
                      >
                        Удалить
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ textAlign: 'center', padding: 40, color: '#999', fontSize: 18 }}>События не найдены</div>
          )}
          {editingEvent && (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ background: 'white', padding: '2rem', borderRadius: 8, width: '90%', maxWidth: 500 }}>
                <h3 style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>Редактирование события</h3>
                <input
                  type="text"
                  placeholder="Название события"
                  value={editingEvent.eventName}
                  onChange={(e) => setEditingEvent({ ...editingEvent, eventName: e.target.value })}
                  style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem', marginBottom: 10 }}
                />
                <textarea
                  placeholder="Описание события"
                  value={editingEvent.description}
                  onChange={(e) => setEditingEvent({ ...editingEvent, description: e.target.value })}
                  style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem', minHeight: 40, marginBottom: 10 }}
                />
                <input
                  type="date"
                  placeholder="Дата события"
                  value={editingEvent.eventDate ? editingEvent.eventDate.split('T')[0] : ''}
                  onChange={(e) => setEditingEvent({ ...editingEvent, eventDate: e.target.value })}
                  style={{ width: '100%', padding: '0.8rem', border: '2px solid #e0e0e0', borderRadius: 4, fontSize: '1rem', marginBottom: 10 }}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '2rem' }}>
                  <button
                    style={{ backgroundColor: 'rgb(151, 1, 14)', color: 'white', borderRadius: 4, padding: '0.8rem 1.5rem', fontSize: '1rem' }}
                    onClick={() => handleEditEvent(editingEvent.id, editingEvent)}
                  >
                    Сохранить
                  </button>
                  <button
                    style={{ backgroundColor: '#666', color: 'white', borderRadius: 4, padding: '0.8rem 1.5rem', fontSize: '1rem' }}
                    onClick={() => setEditingEvent(null)}
                  >
                    Отмена
                  </button>
                </div>
              </div>
            </div>
          )}
          {errorMessage && (
            <div style={{ background: '#ffe3e3', color: '#d32f2f', padding: 15, borderRadius: 8, marginTop: 20, textAlign: 'center' }}>{errorMessage}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageEvents;